/** @jsxImportSource @emotion/react */
import { Helmet } from "react-helmet-async";

export const SEO = ({
  title,
  noindex = false,
  nofollow = false,
  description,
  twitter,
  facebook,
  canonical,
}) => {
  return (
    <Helmet>
      <html lang="en" />
      <title>{title}</title>
      <meta name="description" content={description || "Michelin Tire Testing application"} />
      {canonical && <link rel="canonical" href={canonical} />}

      {/* Robots meta */}
      <meta
        key="robots"
        name="robots"
        content={`${noindex ? "noindex" : "index"},${nofollow ? "nofollow" : "follow"}`}
      />
      <meta
        key="googlebot"
        name="googlebot"
        content={`${noindex ? "noindex" : "index"},${nofollow ? "nofollow" : "follow"}`}
      />

      {/* Twitter meta */}
      {twitter?.cardType && (
        <meta key="twitter:card" name="twitter:card" content={twitter.cardType} />
      )}
      {twitter?.site && <meta key="twitter:site" name="twitter:site" content={twitter.site} />}
      {twitter?.handle && (
        <meta key="twitter:creator" name="twitter:creator" content={twitter.handle} />
      )}

      {/* Facebook meta */}
      {facebook?.appId && <meta key="fb:app_id" property="fb:app_id" content={facebook.appId} />}
    </Helmet>
  );
};
